import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { OrderDetailsBillingObject } from 'src/app/models/orders/order-details-billing/order-details-billing-object.model';
import { BillingOffersObject } from 'src/app/models/orders/order-details-billing/billing-offers/billing-offers-object.model';
import { BillingOffersService } from 'src/app/services/api/billing/obtain-order-billing-offers.service';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-offers-list',
  templateUrl: './offers-list.component.html',
  styleUrls: ['./offers-list.component.css']
})
export class OffersListComponent implements OnInit {

  private offersList: Array<BillingOffersObject>;
  private billing: OrderDetailsBillingObject;
  dataSourceId = 0;
  private diffCharacteristics: CharacteristicsObject;
  @Input() editable: boolean;
  @Input() orderId: string;


  dataSource: MatTableDataSource<BillingOffersObject>;
  columnsToDisplay: string[] = ['offer', 'price', 'discount', 'description'];
  productId: string;

  constructor(
    private activatedRoute: ActivatedRoute, private billingOffersService: BillingOffersService) {
  }

  ngOnInit() {

    this.diffCharacteristics = CharacteristicsObject.create();
    this.billing = new OrderDetailsBillingObject(null, null, new Array<BillingOffersObject>());

    this.activatedRoute.queryParams.subscribe(params => {
      this.productId = params.map;
    });

    this.offersList = new Array<BillingOffersObject>();
    this.dataSource = new MatTableDataSource<BillingOffersObject>(this.offersList);
    this.billing = new OrderDetailsBillingObject(null, 0, this.offersList);
    this.dataSourceId = 0;
  }

  public changeDataSourceId(dataSourceId: number) {
    this.diffCharacteristics = CharacteristicsObject.create();
    this.dataSourceId = dataSourceId;

    let characteristics: CharacteristicsObject = CharacteristicsObject.create();
    for (const offer of this.offersList) {
      if (offer.getId() === dataSourceId) {
        characteristics = new CharacteristicsObject(offer.getInputCharacteristics(), offer.getOutputCharacteristics());
      }
    }

  }

  onCharacteristicsChange($event: CharacteristicsObject) {
    this.diffCharacteristics = $event;
  }

  updateBillingCharacteristics() {
    this.billingOffersService.updateBillingChars(
      this.orderId, this.diffCharacteristics, this.offersList[this.dataSourceId].getOffer()).then(val => {
      }).catch(error => {
        console.error(error);
      });
  }

}
